import { onMounted, ref } from 'vue';
import type { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import type { SupportedEventType, UseEventAggregationOptions, UseEventAggregationReturn } from '@app/interfaces/useEventAggregation.interface';
import { useEventAggregationService } from "@composables/useEventAggregationService";

export const useEventAggregationDependencies = (options: UseEventAggregationOptions): UseEventAggregationReturn => {
	const { waitFor, waitForAll = false, onReady, onEvent } = options;

	const isReady = ref(false);
	const receivedEvents = ref<Set<SupportedEventType>>(new Set());
	let handler: ISubscriber<{ eventType: string }> | null = null;



	onMounted(() => {
		const eventAggregationService = useEventAggregationService();
		if(!eventAggregationService) return;

		const checkAllReady = (): void => {
			const allReceived = waitForAll ? waitFor.every(eventType => receivedEvents.value.has(eventType)) : waitFor.some(eventType => receivedEvents.value.has(eventType));
			if (allReceived && !isReady.value) {
				isReady.value = true;
				onReady?.();
			}
		};

		handler = {
			notify: (event: { eventType: string }): void => {
				const eventType = event.eventType;
				if ((waitFor as readonly string[]).includes(eventType)) {
					receivedEvents.value.add(eventType);
					onEvent?.(eventType);
					checkAllReady();
				}
			}
		};

		// Subscribe only to the events this component cares about
		for (const eventType of waitFor) {
			eventAggregationService.subscribeTo(eventType, handler, true);
		}
	});

	return {
		isReady,
		receivedEvents
	};
};